<template>
  <div>
    <!-- Aow age + 5 = {{ calcAowAge(currentPort.birthday) }}<br>
    Melding 1 jaar = {{ jaarMelding(calcAowAge(currentPort.birthday), 1) }}<br>
    Melding 5 jaar = {{ jaarMelding(calcAowAge(currentPort.birthday), 5) }}<br>
    Aow age = {{ calcAowAge(currentPort.birthday, 0) }}<br>
    Melding 1 jaar = {{ jaarMelding(calcAowAge(currentPort.birthday, 0), 1) }}<br>
    Melding 2 jaar = {{ jaarMelding(calcAowAge(currentPort.birthday, 0), 2) }}<br> -->
    <!-- Alert for 1 year before AOW age and GH-->
    <div
      :class="['msg', 'icon', 'error']"
      v-if='
        Number(currentPort.type) === 9
        && jaarMelding(calcAowAge(currentPort.birthday, 0), 1) < new Date()
      '
    >
      <div class="icon">
        <awesomeIcon icon="info-circle"/>
      </div>
      <div class="alertText">
        <b>Starten met uitkeren.</b><br />
        U heeft (bijna) uw AOW leeftijd bereikt. Dat betekent dat u
        <b>vóór {{ calcAowAge(currentPort.birthday, 0).toLocaleDateString() }}</b> moet starten met
        uitkeren. Neem contact met ons op voor het opstellen van een uitkeerschema. Dit kan links in
        het menu via 'Contact opnemen'.
      </div>
    </div>

    <!-- Alert for 2 years before AOW age and GH-->
    <div
      :class="['msg', 'icon', 'warning']"
      v-else-if='
        Number(currentPort.type) === 9
        && jaarMelding(calcAowAge(currentPort.birthday, 0), 2) < new Date()
      '
    >
      <div class="icon">
        <awesomeIcon icon="info-circle"/>
      </div>
      <div class="alertText">
        <b>Uw AOW leeftijd nadert.</b><br />
        U heeft bijna uw AOW leeftijd bereikt. Dat betekent dat u
        <b>vóór {{ calcAowAge(currentPort.birthday, 0).toLocaleDateString() }}</b> moet starten met
        uitkeren. Neem contact met ons op voor het opstellen van een uitkeerschema. Dit kan links in
        het menu via 'Contact opnemen'.
      </div>
    </div>

    <!-- Alert for AOW age + 5 Lijfrente -->
    <div
      :class="['msg', 'icon', 'error']"
      v-else-if='
        [7, 11].includes(currentPort.type)
        && jaarMelding(calcAowAge(currentPort.birthday), 1) < new Date()
      '
    >
      <div class="icon">
        <awesomeIcon icon="info-circle"/>
      </div>
      <div class="alertText">
        <b>Starten met uitkeren.</b><br />
        U heeft uw AOW leeftijd + 5 jaar (bijna) bereikt. Dat betekent dat u moet starten met
        uitkeren <b>vóór {{ calcAowAge(currentPort.birthday).toLocaleDateString() }}</b>.
        Neem contact met ons op voor het opstellen van een uitkeerschema. Dit kan links in het menu
        via 'Contact opnemen'.
      </div>
    </div>

    <!-- Alert for AOW age + 1 Lijfrente -->
    <div
      :class="['msg', 'icon', 'warning']"
      v-else-if='
        [7, 11].includes(currentPort.type)
        && jaarMelding(calcAowAge(currentPort.birthday), 5) < new Date()
      '
    >
      <div class="icon">
        <awesomeIcon icon="info-circle"/>
      </div>
      <div class="alertText">
        <b>AOW leeftijd bereikt.</b><br />
        U heeft uw AOW leeftijd in {{ calcAowAge(currentPort.birthday, 0).getFullYear() }} bereikt.
        Dat betekent dat u, vanaf uw AOW leeftijd, binnen 5 jaar moet starten met uitkeren. Neem
        contact met ons op wanneer u al wilt starten met uitkeren dan stellen wij een uitkeerschema
        voor u op. Dit kan links in het menu via 'Contact opnemen'.
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'aowAlerts',
  props: {
    currentPort: Object,
  },
  methods: {
    jaarMelding(aowAge, jaar) {
      return new Date(aowAge.getFullYear() - jaar, aowAge.getMonth(), aowAge.getDate());
    },
  },
};
</script>
